import {HistoryState} from '@PosterWhiteboard/poster/poster-history/history-state';
import type {Delta} from 'jsondiffpatch';
import {reverse} from 'jsondiffpatch';

export class HistoryStatePosterDiff extends HistoryState {
  public patchForRedo: Delta;
  private patchForUndo: Delta | null = null;

  public constructor(patchForRedo: Delta) {
    super();
    this.patchForRedo = patchForRedo;
  }

  public getPatchForUndo(): Delta {
    this.patchForUndo ??= reverse(this.patchForRedo);
    return this.patchForUndo;
  }
}
